module.exports = __webpack_public_path__ + "media/images/prof_sidebar_bottom-8cab02f72f30daf906d64dfccc6be2f6.png";